import { NdtStep, config } from "./helpers";

export default function() {
    return NdtStep('step7', 'Step 7: Please provide the following: (If you choose, you may use dollar amounts for a period of time less than the entire year (e.g., a single month) to make this calculation easier).', {
        nextComponent: () => null,
        passed() {
            let { totalCostOfBenefits, totalCostKeyEmployees } = this;
            return totalCostOfBenefits == 0 || (totalCostKeyEmployees / totalCostOfBenefits) < 0.25;
        },
        keyEmployees: () => [
            config.keyEmployee,
            'A person with ownership of more-than-5% of the employer entity or',
            'A person with ownership of more than 1% of the employer entity* with an annual compensation over $150,000'
        ],
        nextEnabled() {
            var props = ['totalCostOfBenefits', 'totalCostKeyEmployees']
            return props.every(p => this.answers[p] != null);
        },
        details() {
             return [
                 { question: 'Step 7: Total Cost of all benefits for all employees under the plan', result: `$${this.totalCostOfBenefits}` },
                 { question: 'Step 7: Total cost of all benefits for key employees ONLY under the plan', result: `$${this.totalCostKeyEmployees}`}
             ];
        },
        template: `
        <div>
            <q-title :text="question" />
            <div class="px-2 row">
                <help-block label='"Total cost of all benefits" = Total benefits premiums paid by BOTH the employee and the employer for all pre-taxed benefits' />
                <help-block label="Remember that a Key Employee is any of the following:" :items="keyEmployees">
                    <template v-slot:additional-info>
                        *Please note that certain "ownership attribution" rules apply for determining business ownership with regard to family
                        members. Generally, an individual is deemed to own the interest held by his or her spouse (other than one who
                        is legally separated), children, grandchildren, and parents.
                    </template>
                </help-block>
            </div>
            <div class="px-2 row">
                <amf-input label="Total Cost of all benefits for all employees under the plan" inputType="number" v-model="answers.totalCostOfBenefits" aggressive/>
            </div>
            <div class="px-2 row">
                <amf-input label="Total cost of all benefits for key employees ONLY under the plan" inputType="number" v-model="answers.totalCostKeyEmployees" aggressive/>
            </div>
        </div>`
    })
}


// WEBPACK FOOTER //
// ./src/shared/Nondiscrimination/POP/step7.js